/**
 * Check if the current platform is macOS
 * 检查当前平台是否为 macOS
 * @returns {boolean} Returns true if the current platform is macOS
 */
export function isMacOS(): boolean {
  // 使用现代的 userAgentData API
  if ('userAgentData' in navigator && (navigator as any).userAgentData?.platform)
    return (navigator as any).userAgentData.platform === 'macOS'

  // 降级方案：使用 userAgent
  const userAgent = navigator.userAgent.toLowerCase()
  return userAgent.includes('mac')
         || userAgent.includes('darwin')
}

/**
 * Check if the current platform is Windows
 * 检查当前平台是否为 Windows
 * @returns {boolean} Returns true if the current platform is Windows
 */
export function isWindows(): boolean {
  // 使用现代的 userAgentData API
  if ('userAgentData' in navigator && (navigator as any).userAgentData?.platform)
    return (navigator as any).userAgentData.platform === 'Windows'

  // 降级方案：使用 userAgent
  const userAgent = navigator.userAgent.toLowerCase()
  return userAgent.includes('windows')
         || userAgent.includes('win64')
         || userAgent.includes('win32')
         || userAgent.includes('windows nt')
}
